<template>
  <b-modal class="modal-xl" size="xl" id="agreement-modal" ref="userAgreementModal" :header-bg-variant="'secondary'" centered hide-backdrop okVariant="secondary" no-close-on-esc no-close-on-backdrop and hide-header-close>
    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title text-light"><fontAwesomeIcon :icon="['fa', 'info']" size="1x" class="mr-2"/>{{ t('userAgreementModalHeader', 'userAgreementModalHeader') }}</h5>
    </template>
    <template slot="default">
      <div class="col-12 text-left eula-text">
        <CorcentricPrivacyPolicy />
      </div>
    </template>
    <template slot="modal-footer">
      <div class="col-12 px-0">
        <div class="col-12 px-0 right-content">
          <b-form-checkbox
          id="checkbox-1"
          v-model="agreementStatus"
          name="checkbox-1"
          :value="true"
          :unchecked-value="false"
          >
            {{ t('acceptAgreementCheckboxText', 'acceptAgreementCheckboxText') }}
          </b-form-checkbox>
        </div>
        <div class="col-12 px-0 text-right">
          <button :disabled="!agreementStatus" class="btn btn-primary mt-2 mr-2" @click="sendUserAgreement()">{{ t('sendUserAgreementButton', 'sendUserAgreementButton') }}</button>
          <button :disabled="isBusy" class="btn btn-danger mt-2" @click="denyUserAgreement()">{{ t('denyUserAgreementButton', 'denyUserAgreementButton') }}</button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import CorcentricPrivacyPolicy from '@/components/Helper_Components/CorcentricPrivacyPolicy.vue'

export default {
  name: 'UserAgreementModal',
  data() {
    return {
      agreementStatus: false,
      isBusy: false,
      privacyText: null
    }
  },
  components: {
    CorcentricPrivacyPolicy
  },
  mounted() {
    //this.privacyText = require('@/assets/CorcentricPrivacyPolicy.html')
  },
  computed: {
    btnEnabled() {
      if(agreementStatus) {
        return true
      }

      return false
    }
  },
  methods: {
    denyUserAgreement() {
      this.isBusy = true
      this.$store.dispatch('rejectUserAgreement', null).then( response => {
        if(response.status && response.status != 'error') {
          this.isBusy = false
          this.$parent.hideAgreementModal()
          this.$store.dispatch('logOut', 'userAgreementNotAccepted')
        } 
      }, this) 
    },
    sendUserAgreement() {
      if(!this.agreementStatus) {
        // if the user does not accept the EULA, log them out PW
        this.$parent.hideAgreementModal()
        this.$store.dispatch('logOut', 'userAgreementNotAccepted')
      } else {
        let data = {}
        data.status = this.agreementStatus

        this.$store.dispatch('sendUserAgreement', data).then(response => {
          if(response.status && response.status != 'error') {
            this.$parent.hideAgreementModal()
          }
        }, this)
      }
    }
  }
}
</script>

<style>
.right-content {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.eula-text {
  min-height: 50vh;
  max-height: 70vh;
  overflow-y: scroll;
  padding-left: 30px;
  padding-right: 30px;
}

@media (min-width: 992px)
{
  .modal-lg, .modal-xl {
    max-width: 800px;
  }
}

@media (min-width: 1200px)
{
  .modal-xl {
    max-width: 1140px;
  }
}
</style>
